// Абсолютное позиционирование элемента на холсте 1920×1080
export function box(x, y, w, h) {
    return {left: `${x}px`, top: `${y}px`, width: `${w}px`, height: `${h}px`}
}
